import { config } from 'config'
import { Section } from 'components/section'
import {
  Article,
  Content,
  Description,
  Image,
  Item,
  List,
  Title,
} from './styled'

const articles = [
  {
    img: require('./images/chapter1.webp'),
    title: '"Каждая женщина заслуживает жить спокойно и достойно"',
    description:
      'Спустя десять лет насилия Айзат спасла себя и теперь помогает другим',
  },
  {
    img: require('./images/chapter2.webp'),
    title: 'Солидарность и поддержка в сети',
    description:
      'Как девушка из Казахстана ушла от абьюзера благодаря женскому форуму и почему решила вернуться',
  },
  {
    img: require('./images/chapter3.webp'),
    title: 'Хизмат с рассвета и постоянные упреки',
    description:
      'Как келин в Таджикистане страдают от психологического насилия',
  },
  {
    img: require('./images/chapter4.webp'),
    title: '"Мне казалось, что я хрупкая и беззащитная"',
    description:
      'Как Улжан посадила насильника в тюрьму вопреки угрозам полиции и публичной травле',
  },
  {
    img: require('./images/chapter5.webp'),
    title: '"Я хотела, чтобы мои дети понимали: насилие – это ненормально"',
    description:
      'Как Ирода освободилась от 25-летнего насилия и открыла бизнес своей мечты в Узбекистане',
  },
]

export const Articles = () => (
  <Section containerType="restricted">
    <List>
      {articles.map((article, i) => (
        <Item key={i}>
          <a
            href={`${config.urlBefore}${config.pages[i + 1].id}${
              config.urlAfter
            }`}
          >
            <Article>
              <Image src={article.img} />
              <Content>
                <Title>{article.title}</Title>
                <Description>{article.description}</Description>
              </Content>
            </Article>
          </a>
        </Item>
      ))}
    </List>
  </Section>
)
